import React from 'react'
import { Box } from '@mui/material'
import { getIn, useFormikContext } from 'formik'
import { LocationTypesEnum } from '../../../pages/adgroup/settings/geoTargeting/GeoTargetingFields'
import { AutoCompleteGoogleMapFieldProps } from '../autoCompleteGoogleMapField/intefaces'
import LocationsPanel from './LocationsPanel'

type ReadOnlyLocationsFieldProps = Pick<
  AutoCompleteGoogleMapFieldProps,
  'name' | 'label' | 'locationType' | 'compact' | 'countryCode'
> & {
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  /** The locations are excluded rather than targeted; read from `ruleFieldName` when it is set */
  exclusive?: boolean
  ruleFieldName?: string
}

/** Read mode: search and pagination only, no edit controls */
const ReadOnlyLocationsField: React.FC<ReadOnlyLocationsFieldProps> = ({
  name,
  locationType = LocationTypesEnum.Cities,
  compact = false,
  countryCode,
  onMouseEnter,
  onMouseLeave,
  exclusive = false,
  ruleFieldName,
}) => {
  const { values } = useFormikContext<unknown>()

  return (
    <Box onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} sx={{ width: '100%', mt: compact ? 0 : 2 }}>
      <LocationsPanel
        key={name}
        name={name}
        locationType={locationType}
        mode="read"
        compact={compact}
        countryCode={countryCode}
        exclusive={ruleFieldName ? Boolean(getIn(values, ruleFieldName)) : exclusive}
      />
    </Box>
  )
}

export default ReadOnlyLocationsField
